import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import GalleryPreview from "./components/GalleryPreview";
import B2BSection from "./components/B2BSection";
import QuoteSection from "./components/QuoteSection";
import TestimonialsSection from "./components/TestimonialsSection";
import JsonLd from "../../components/feature/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "SPDB Studio",
  "url": siteUrl,
  "description": "Single Property Digital Branding für Luxusimmobilien ab 2 Mio. CHF in der Schweiz",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/gallery`,
    "query-input": "required name=search_term_string"
  }
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SPDB Studio",
  "description": "SPDB Studio – Single Property Digital Branding für Luxusimmobilien ab 2 Mio. CHF. Exklusives Immobilien-Webdesign und Storytelling für Luxusmakler in der Schweiz.",
  "url": siteUrl,
  "email": "studio@sbdm-studio.ch",
  "telephone": "+41766827078",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Bahnhofstrasse 42",
    "addressLocality": "Zürich",
    "postalCode": "8001",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 47.3769,
    "longitude": 8.5417
  },
  "areaServed": {
    "@type": "Country",
    "name": "Schweiz"
  },
  "serviceType": [
    "Single Property Branding",
    "Luxusimmobilien Webdesign",
    "Immobilien Storytelling",
    "Landingpage Erstellung"
  ],
  "priceRange": "CHF 3.500+",
  "image": `${siteUrl}/og-image.jpg`,
  "sameAs": []
};

export default function HomePage() {
  return (
    <>
      <title>SPDB Studio | Kreativbüro für Luxusimmobilien</title>
      <meta name="description" content="SPDB Studio – Wir verwandeln Premium-Immobilien ab 2 Mio. CHF in digitale Erlebnisse. Exklusives Single Property Branding, individuelle Landingpages und Storytelling für Luxusmakler in der Schweiz." />
      <meta name="keywords" content="Single Property Branding, Luxusimmobilien Schweiz, Immobilien Webdesign, Makler Marketing Zürich" />
      <link rel="canonical" href={siteUrl} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <main className="min-h-screen">
        <Navbar />
        <HeroSection />
        <GalleryPreview />
        <B2BSection />
        <TestimonialsSection />
        <QuoteSection />
        <Footer />
      </main>
    </>
  );
}